module.exports = __webpack_public_path__ + "static/media/CarryOn_Backpack_Arrows_iOS12Fix.0e9b2f3b.usdz";